var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-create',_vm._g(_vm._b({attrs:{"name":"projects-create","title":_vm.$t('projects.form.create')}},'base-create',_vm.$attrs,false),_vm.$listeners),[_c('projects-form',{attrs:{"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }